import * as React from "react";
import { useEventCallback } from "../../hooks/index.js";
import { useTimeouts } from "../../contexts/index.js";
import { SwipeState } from "./index.js";
import { EVENT_ON_WHEEL } from "../../consts.js";
export var useWheelSwipe = function useWheelSwipe(swipeState, subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel) {
  var offset = React.useRef(0);
  var intent = React.useRef(0);
  var intentCleanup = React.useRef();
  var resetCleanup = React.useRef();
  var wheelResidualMomentum = React.useRef(0);
  var startTime = React.useRef(0);
  var _useTimeouts = useTimeouts(),
    setTimeout = _useTimeouts.setTimeout,
    clearTimeout = _useTimeouts.clearTimeout;
  var cancelSwipeIntentCleanup = React.useCallback(function () {
    if (intentCleanup.current) {
      clearTimeout(intentCleanup.current);
      intentCleanup.current = undefined;
    }
  }, [clearTimeout]);
  var cancelSwipeResetCleanup = React.useCallback(function () {
    if (resetCleanup.current) {
      clearTimeout(resetCleanup.current);
      resetCleanup.current = undefined;
    }
  }, [clearTimeout]);
  var handleCleanup = useEventCallback(function () {
    if (swipeState !== SwipeState.SWIPE) {
      offset.current = 0;
      startTime.current = 0;
      cancelSwipeIntentCleanup();
      cancelSwipeResetCleanup();
    }
  });
  React.useEffect(handleCleanup, [swipeState, handleCleanup]);
  var handleCancelSwipe = useEventCallback(function (currentSwipeOffset) {
    resetCleanup.current = undefined;
    if (offset.current === currentSwipeOffset) {
      onSwipeCancel(offset.current);
    }
  });
  var onWheel = useEventCallback(function (event) {
    if (event.ctrlKey) {
      return;
    }
    if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
      return;
    }
    if (!swipeState) {
      if (Math.abs(event.deltaX) <= 1.2 * Math.abs(wheelResidualMomentum.current)) {
        wheelResidualMomentum.current = event.deltaX;
        return;
      }
      if (!isSwipeValid(-event.deltaX)) {
        return;
      }
      intent.current += event.deltaX;
      cancelSwipeIntentCleanup();
      if (Math.abs(intent.current) > 30) {
        intent.current = 0;
        wheelResidualMomentum.current = 0;
        startTime.current = Date.now();
        onSwipeStart();
      } else {
        var currentSwipeIntent = intent.current;
        intentCleanup.current = setTimeout(function () {
          intentCleanup.current = undefined;
          if (currentSwipeIntent === intent.current) {
            intent.current = 0;
          }
        }, swipeAnimationDuration);
      }
    } else if (swipeState === SwipeState.SWIPE) {
      var newSwipeOffset = offset.current - event.deltaX;
      newSwipeOffset = Math.min(Math.abs(newSwipeOffset), containerWidth) * Math.sign(newSwipeOffset);
      offset.current = newSwipeOffset;
      onSwipeProgress(newSwipeOffset);
      cancelSwipeResetCleanup();
      if (Math.abs(newSwipeOffset) > 0.2 * containerWidth) {
        wheelResidualMomentum.current = event.deltaX;
        onSwipeFinish(newSwipeOffset, Date.now() - startTime.current);
        return;
      }
      resetCleanup.current = setTimeout(function () {
        return handleCancelSwipe(newSwipeOffset);
      }, 2 * swipeAnimationDuration);
    } else {
      wheelResidualMomentum.current = event.deltaX;
    }
  });
  React.useEffect(function () {
    return subscribeSensors(EVENT_ON_WHEEL, onWheel);
  }, [subscribeSensors, onWheel]);
};